import React from "react";
import { CellContentType, RowType } from "./types";

export function NameLinkFormatter(cellContent: CellContentType, row: RowType) {
  return (
    <span>
      <a
        href={`/operation/notices/${row.id}/view`}
        target="_blank"
        rel="noopener noreferrer"
      >
        {row.name}
      </a>
    </span>
  );
}
